import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { COLORS } from "components";

interface CountBoxProps {
  label: string;
  sublabel: string;
  count: number | null;
  isLoading: boolean;
  isWarning?: boolean;
}

export const CountBox = ({
  label,
  sublabel,
  count,
  isLoading,
  isWarning = false,
}: CountBoxProps) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      pb: 2,
      mb: 1.75,
      borderBottom: "1px solid #e8eeee",
    }}
  >
    <Box>
      <Typography
        sx={{
          fontSize: "11px",
          fontWeight: 700,
          color: isWarning ? "#c0392b" : COLORS.Mainblue,
          textTransform: "uppercase",
          letterSpacing: "0.5px",
        }}
      >
        {label}
      </Typography>
      <Typography sx={{ fontSize: "12px", color: "#8aa0a0", mt: "2px" }}>
        {sublabel}
      </Typography>
    </Box>
    <Box sx={{ minHeight: "38px", display: "flex", alignItems: "center" }}>
      {isLoading ? (
        <CircularProgress size={20} />
      ) : (
        <Typography
          sx={{
            fontSize: "30px",
            fontWeight: 800,
            color: isWarning ? "#c0392b" : COLORS.Mainblue,
          }}
        >
          {count === null ? "–" : count.toLocaleString()}
        </Typography>
      )}
    </Box>
  </Box>
);
